module.exports = __webpack_public_path__ + "static/img/banner2.555d76d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/picture/banner/banner2.jpg
// module id = RR0R
// module chunks = 0